export enum AlarmSettingsType {
  LIMIT = 'LIMIT',
  LIMIT_PERCENTAGE = 'LIMIT_PERCENTAGE',
  GEOFENCE = 'GEOFENCE',
  TIMEFENCING = 'TIMEFENCING',
  TELEMATICS_UNIT = 'TELEMATICS_UNIT',
  TRACKER_BATTERY_STATUS = 'TRACKER_BATTERY_STATUS',
}
